// Iter 108v — NewTicketDialog extracted from Helpdesk.jsx.

import { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";
import { PRIORITIES } from "./helpdeskUtils";

export function NewTicketDialog({ onClose, onCreated }) {
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [priority, setPriority] = useState("normal");
  const [saving, setSaving] = useState(false);
  const submit = async () => {
    if (!subject.trim()) return;
    setSaving(true);
    try {
      const { data } = await api.post("/helpdesk/tickets", {
        subject: subject.trim(), body_text: body, priority,
      });
      toast.success(`Ticket ${data.cf_id} created`);
      onCreated(data);
    } catch { toast.error("Could not create ticket"); } finally { setSaving(false); }
  };
  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent data-testid="helpdesk-new-dialog">
        <DialogHeader><DialogTitle>New ticket</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div>
            <label className="mb-1 block text-xs font-semibold uppercase text-slate-500">Subject</label>
            <Input value={subject} onChange={(e) => setSubject(e.target.value)} data-testid="helpdesk-new-subject" />
          </div>
          <div>
            <label className="mb-1 block text-xs font-semibold uppercase text-slate-500">Description</label>
            <Textarea value={body} onChange={(e) => setBody(e.target.value)} rows={5} data-testid="helpdesk-new-body" />
          </div>
          <div>
            <label className="mb-1 block text-xs font-semibold uppercase text-slate-500">Priority</label>
            <Select value={priority} onValueChange={setPriority}>
              <SelectTrigger data-testid="helpdesk-new-priority"><SelectValue /></SelectTrigger>
              <SelectContent>{PRIORITIES.map((p) => <SelectItem key={p} value={p}>{p}</SelectItem>)}</SelectContent>
            </Select>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button onClick={submit} disabled={saving || !subject.trim()} data-testid="helpdesk-new-submit">
            {saving ? "Creating…" : "Create ticket"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
